/**
 * giftCardsRoutes — the two Gift-cards routes (BON-223), defined here rather
 * than inline in `AdminRoutes.tsx` so the route table and its permission gate
 * live together in this feature folder (the `reviewRoutes` pattern). Paths are
 * relative — admin mode's tree mounts them under `/admin/*`.
 *
 * Gated on `read:gift_cards` ALONE — deliberately NOT `anyOf` with
 * `read:all`. RD/Finance/Marketing hold `read:all` but must not see gift-card
 * balances or ledgers, so the admin sentinel does not widen this gate the way
 * it does for `/admin/bookings` or `/admin/needs-review`.
 */
import { Route } from 'react-router-dom';

import RequirePermission from '../../shared/RequirePermission';
import { Permission } from '../../types/permissions';

import GiftCardDetailPage from './GiftCardDetailPage';
import GiftCardsListPage from './GiftCardsListPage';

export const giftCardsRoutes = (
  <>
    <Route
      path="gift-cards"
      element={
        <RequirePermission permission={Permission.READ_GIFT_CARDS}>
          <GiftCardsListPage />
        </RequirePermission>
      }
    />
    <Route
      path="gift-cards/:id"
      element={
        <RequirePermission permission={Permission.READ_GIFT_CARDS}>
          <GiftCardDetailPage />
        </RequirePermission>
      }
    />
  </>
);
